import type { Catalog } from '@smarton-pbx/shared';

/** The sales pipeline: the board, a lead's panel and form. Stage names are in common. */
export const pipeline: Catalog = {
  Lead: 'Potencialus klientas',
  'Everyone your team calls to sell to, by where they stand. Calls nobody answers move them by themselves.':
    'Visi, kuriems jūsų komanda skambina siūlydama paslaugas, suskirstyti pagal etapus. Kai niekas neatsiliepia, skambutis juos perkelia pats.',
  'New lead': 'Naujas potencialus klientas',
  'Whose leads': 'Kieno potencialūs klientai',
  'Everyone’s': 'Visų',
  'Mine and nobody’s': 'Mano ir niekieno',
  Mine: 'Mano',
  'Nobody’s': 'Niekieno',
  'Where they came from': 'Iš kur atėjo',
  'All sources': 'Visi šaltiniai',
  'No source': 'Be šaltinio',
  'When they were added': 'Kada pridėti',
  'Added any time': 'Pridėti bet kada',
  'Added today': 'Pridėti šiandien',
  'Added in the last 7 days': 'Pridėti per 7 dienas',
  'Added this month': 'Pridėti šį mėnesį',
  'Added in the last 30 days': 'Pridėti per 30 dienų',
  'Added between…': 'Pridėti nuo–iki…',
  'Added from': 'Pridėti nuo',
  'Added to': 'Pridėti iki',
  'Company, name, number, email, source…': 'Įmonė, vardas, numeris, el. paštas, šaltinis…',
  'Search leads': 'Ieškoti potencialių klientų',
  '{n} to call today': 'Šiandien skambinti: {n}',
  'To call today': 'Šiandien skambinti',
  'No leads': 'Tuščia',
  'Show more ({n})': 'Rodyti daugiau ({n})',
  'Talked · set the result': 'Kalbėta · pažymėkite rezultatą',
  'Missed their call': 'Praleistas skambutis',
  'Number not in use': 'Numeris nenaudojamas',
  'Tried {n}×': 'Bandyta {n} k.',

  // A lead's panel and form (LeadPanel.tsx).
  'You talked {when}. What came of it? Pick where they stand now.': 'Kalbėjote {when}. Kuo baigėsi? Pasirinkite dabartinį etapą.',
  'Where they stand': 'Etapas',
  'Next call': 'Kitas skambutis',
  Tomorrow: 'Rytoj',
  'In a week': 'Po savaitės',
  'No next call': 'Be kito skambučio',
  'Time of the next call': 'Kito skambučio laikas',
  'At a time, if you agreed one': 'Laikas, jei susitarėte',
  'Who works it': 'Atsakingas',
  '{name} (you)': '{name} (jūs)',
  'Save notes': 'Išsaugoti pastabas',
  'What they do': 'Veikla',
  'Interested in': 'Domina',
  Source: 'Šaltinis',
  Added: 'Pridėta',
  'Facebook, cold call…': 'Facebook, šaltas skambutis…',
  // Suggested sources (the team's own words come first).
  'Cold call': 'Šaltas skambutis',
  Website: 'Svetainė',
  Referral: 'Rekomendacija',
  'No calls with them yet.': 'Skambučių dar nebuvo.',
  'Delete lead': 'Ištrinti potencialų klientą',
  'Next lead': 'Kitas',
  // The people at a lead's company.
  'lead|People': 'Kontaktiniai asmenys',
  'lead|Add person': 'Pridėti asmenį',
  'Nobody yet. Add the people you talk to there.': 'Dar nieko nėra. Pridėkite asmenis, su kuriais kalbate.',
  Position: 'Pareigos',
  'Director, accountant…': 'Direktorius, buhalterė…',
  'Cafés and restaurants': 'Kavinės ir restoranai',
  'Accounting, POS': 'Apskaita, kasos sistema',
};
